import { render } from "./PlainRouterView.vue?vue&type=template&id=b8a52b8a"
import script from "./PlainRouterView.vue?vue&type=script&lang=js"
export * from "./PlainRouterView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__